import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoggerService } from '../services/logger/logger.service';
import { catchError, throwError } from 'rxjs';
import { LogsType } from '../../shared/constants/logs-type.enum';

export const errorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const className = 'errorInterceptor';
  const logger = inject(LoggerService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = '';
      let errorError = '';

      if (error.error instanceof ErrorEvent) {
        errorMessage = error.error.message;
      } else {
        switch (error.status) {
          case 401:
          case 400:
          case 403:
          case 404:
          case 409:
          case 500:
            errorError = error.error?.error;
            errorMessage = error.message;
            break;
          default:
            errorMessage = error.message;
            break;
        }
      }
      logger.logMessage(LogsType.ERROR, className, '', 'Erro HTTP: ', errorMessage, (errorError ? `\n Adicional: ${errorError}` : ''));

      return throwError(() => error);
    })
  );
};
